import { Result } from 'antd';
import styled from 'styled-components';

export const ResultContainer = styled(Result)`
  //margin: 16px 24px 24px;
  padding: 20px 0;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: var(--v3-black-0);
`;
